export const CHWZ = {
    rapidstor: {
        payNowButtonText: '立即付款',
        payLaterButtonText: '稍後付款',
        saveQuoteButtonText: '保存報價',
        showPricesButtonText: '顯示價格',
        noAvailableUnitsText: '現在致電我們',
    },
};
